import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './vehicle-position.reducer';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehiclePositionUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const vehiclePositionEntity = useAppSelector(state => state.vehiclePosition.entity);
  const loading = useAppSelector(state => state.vehiclePosition.loading);
  const updating = useAppSelector(state => state.vehiclePosition.updating);
  const updateSuccess = useAppSelector(state => state.vehiclePosition.updateSuccess);

  const handleClose = () => {
    props.history.push('/vehicle-position' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...vehiclePositionEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      user: users.find(it => it.id.toString() === values.userId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...vehiclePositionEntity,
          created: convertDateTimeFromServer(vehiclePositionEntity.created),
          truckImplementId: vehiclePositionEntity?.truckImplement?.id,
          companyId: vehiclePositionEntity?.company?.id,
          userId: vehiclePositionEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.vehiclePosition.home.createOrEditLabel" data-cy="VehiclePositionCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.vehiclePosition.home.createOrEditLabel">Create or edit a VehiclePosition</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="vehicle-position-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePosition.createdDate')}
                id="vehicle-position-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePosition.latitude')}
                id="vehicle-position-latitude"
                name="latitude"
                data-cy="latitude"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePosition.longitude')}
                id="vehicle-position-longitude"
                name="longitude"
                data-cy="longitude"
                type="text"
              />
              <ValidatedField
                id="vehicle-position-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.vehiclePosition.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="vehicle-position-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.vehiclePosition.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="vehicle-position-user"
                name="userId"
                data-cy="user"
                label={translate('fleetSenseApp.vehiclePosition.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/vehicle-position" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default VehiclePositionUpdate;
